import { z } from 'zod';
/** NIST RMF 3-category + NIST 600-1 risk vectors. */
export const RISK_VECTORS = [
    'physical_safety', 'psychological_harm', 'economic_opportunity',
    'rights_violations', 'civil_liberties',
    'data_confidentiality', 'operational_disruption', 'model_integrity',
    'intellectual_property',
    'infrastructure_disruption', 'systemic_bias', 'environmental',
    'democratic_integrity', 'supply_chain',
    // V117-4-2: harms to people the state AI laws target that no vector above covers.
    'personal_privacy', 'deception',
];
export const riskVectorSchema = z.array(z.enum(RISK_VECTORS)).default([]);
/** Maps each risk vector to its NIST harm category. */
export const RISK_VECTOR_CATEGORIES = {
    physical_safety: 'harm_to_people',
    psychological_harm: 'harm_to_people',
    economic_opportunity: 'harm_to_people',
    rights_violations: 'harm_to_people',
    civil_liberties: 'harm_to_people',
    data_confidentiality: 'harm_to_organizations',
    operational_disruption: 'harm_to_organizations',
    model_integrity: 'harm_to_organizations',
    intellectual_property: 'harm_to_organizations',
    infrastructure_disruption: 'harm_to_ecosystems',
    systemic_bias: 'harm_to_ecosystems',
    environmental: 'harm_to_ecosystems',
    democratic_integrity: 'harm_to_ecosystems',
    supply_chain: 'harm_to_ecosystems',
    personal_privacy: 'harm_to_people',
    deception: 'harm_to_people',
};
export const RISK_VECTOR_LABELS = {
    physical_safety: 'Physical Safety',
    psychological_harm: 'Psychological Harm',
    economic_opportunity: 'Economic Opportunity',
    rights_violations: 'Rights Violations',
    civil_liberties: 'Civil Liberties',
    data_confidentiality: 'Data Confidentiality',
    operational_disruption: 'Operational Disruption',
    model_integrity: 'Model Integrity',
    intellectual_property: 'Intellectual Property',
    infrastructure_disruption: 'Infrastructure Disruption',
    systemic_bias: 'Systemic Bias',
    environmental: 'Environmental Impact',
    democratic_integrity: 'Democratic Integrity',
    supply_chain: 'Supply Chain',
    personal_privacy: 'Personal Privacy',
    deception: 'Deception About AI',
};
//# sourceMappingURL=risk-vectors.js.map